import localforage from "localforage";


const class9Record = localforage.createInstance({
    drivers : [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
    name: "SMS",
    storeName: "class9Record"
});


const setClass9Record = (key, value) => {
// console.log("setClass9Record----->",key, value);
class9Record.setItem(key, value);
    
      };


      const getClass9Record = (key) => {
        // console.log("getClass9Record----->",key);
        class9Record.getItem(key).then(function () {
                    // console.log("CHECKING RESPONSE GET ITEM:",class9Record.getItem(key));
                  }).then(function (value) {
                    // we got our value
                  }).catch(function (err) {
                    // we got an error
                  });  
            
              };

      


    export {getClass9Record, setClass9Record};
















// import localforage from "localforage";


// const class9Record = localforage.createInstance({
//     drivers : [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
//     name: "SMS",
//     storeName: "Class9Record"
// });


// const setClass9Record = (key, value) => {
// console.log("setClass9Record----->",key, value)
//     class9Record.setItem(key, value);   

//   };





